import dynamic from 'next/dynamic';
import HeadTags from '@/vdp/HeadTags';
import { VehicleDetailsLiteContainer } from '@/vdp/VehicleDetailsContainer';
import { vdpLitePage, vdpTrack } from '~/constants/eventable';
import VehicleDetailsProviders, {
  VehicleDetailsProvidersProps
} from '~/context/vdp/VehicleDetailsProviders';
import getVehicleDetailsServerSideProps from '~/server-props/vdp/getVehicleDetailsServerSideProps';
import setLite from '~/server-props/vdp/setLite';
import reduxWrapper from '~/store/configureStore';
import { ErrorBoundary } from '~/utilities/ErrorBoundary';

const TrackPageExit = dynamic(
  () =>
    import(
      /* webpackChunkName: "TrackPageExit" */ '@/vdp/Analytics/TrackPageExit'
    ),
  { ssr: false }
);

type OwnProps = {
  forProviders: VehicleDetailsProvidersProps;
};

export default function VehicleDetailsPage(props: OwnProps) {
  return (
    <>
      <ErrorBoundary>
        <VehicleDetailsProviders
          eventableProject={vdpLitePage}
          eventableTrack={vdpTrack}
          {...props.forProviders}
        >
          <HeadTags nofollow />
          <TrackPageExit />
          <VehicleDetailsLiteContainer />
        </VehicleDetailsProviders>
      </ErrorBoundary>
    </>
  );
}

export const getServerSideProps = reduxWrapper.getServerSideProps(
  store => context => {
    setLite(store);

    return getVehicleDetailsServerSideProps({
      context,
      page: vdpLitePage,
      store
    });
  }
);
